// FormControlEmployee component

import React from "react";
import { FormControl, FormLabel, FormErrorMessage } from "@chakra-ui/react";
import Select from "react-select";
import {
  newBorder,
  white,
  primary,
  textPrimary,
  textSecondary,
  backgroundLight,
} from "../../utils/colors";
import { useTranslation } from "react-i18next";

const FormControlRepresentativeType = ({
  label,
  value,
  onChange,
  isRequired,
  isTouched,
  isError,
  errorMessage,
  w,
  isSmall,
  isMulti,
  placeholder,
  noBottom,
}) => {
  // TRANSLATION
  const { t } = useTranslation();

  // Hardcoded options for tenant type
  const options = [
    { value: "parent", label: t("patient.representativeParent") },
    { value: "family", label: t("patient.representativeFamily") },
    { value: "other", label: t("patient.representativeOther") },
  ];

  // Find the selected option based on the current value
  const selectedOption =
    options.find((option) => option.value === value) || null;
  const filteredOptions = options.filter((option) => option.value !== value);

  // console.log("value", value);
  // console.log("selectedOption", selectedOption);

  // Custom styles for react-select
  // Custom styles for react-select
  const customStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      borderColor: isError ? "red" : state.isFocused ? newBorder : newBorder,
      backgroundColor: white,
      border: `1px solid ${newBorder}`,
      fontSize: isSmall ? "0.875rem" : "0.938rem",
      fontWeight: "500",
      minHeight: isSmall ? "2.5rem" : "3rem",
      height: isMulti ? "initial" : isSmall ? "2.5rem" : "3rem",
      margin: "0",
      padding: "0 8px",
      borderRadius: "0.75rem",

      ":focus-visible": {
        borderColor: primary,
        boxShadow: `0 0 0 1px ${newBorder}`,
      },
      ":hover": {
        boxShadow: "none",
        outline: "none",
      },
    }),

    menu: (provided) => ({
      ...provided,
      borderRadius: "0.75rem",
      boxShadow: "1px 1px 6px rgba(0, 0, 0, 0.3)",
      border: `0px solid ${newBorder}`,
      overflow: "hidden",
      zIndex: 1000,
    }),

    menuList: (provided) => ({
      ...provided,
      margin: "0",
      padding: "0",
      border: "none",
      boxShadow: "none",
    }),

    singleValue: (provided, state) => ({
      ...provided,
      opacity: state.isDisabled ? 0.5 : 1,
      color: textPrimary,
      margin: "0",
      padding: "0 0px",

      ":hover": {
        bg: "red",
      },
    }),

    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? backgroundLight : null,
      color: state.isFocused ? textPrimary : state.data.color,
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      margin: "0",
      padding: "0 1rem",
      fontWeight: "500",
      height: "48px",
      fontSize: "0.875rem",
      borderBottom: `1px solid ${newBorder}`,
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: primary,
      color: white,
      fontSize: "0.938rem",
    }),
    multiValueLabel: (provided, state) => ({
      ...provided,
      color: state.data.color,
    }),
    multiValueRemove: (provided, state) => ({
      ...provided,
      ":hover": {
        backgroundColor: state.data.bgDark,
        color: state.data.color,
      },
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontSize: "11px",
      color: textSecondary,
      fontWeight: "500",
    }),
  };

  // console.log("value", value);
  // console.log("selectedOption", selectedOption);

  return (
    <FormControl
      mb={noBottom ? 0 : 4}
      isRequired={isRequired}
      isInvalid={isTouched && isError}
      w={w}
    >
      <FormLabel fontSize={isSmall ? "xs" : "sm"} position="relative">
        {label}
        {isError && isTouched && (
          <FormErrorMessage fontSize="xs">{errorMessage}</FormErrorMessage>
        )}
      </FormLabel>
      <Select
        isMulti={isMulti}
        isSearchable={false}
        value={selectedOption}
        onChange={onChange}
        options={filteredOptions}
        placeholder={placeholder}
        styles={customStyles}
      />
    </FormControl>
  );
};

export default FormControlRepresentativeType;
